"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _chevronLeft = _interopRequireDefault(require("@atlaskit/icon/utility/chevron-left"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ChevronLeftLargeIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
}, props, {
  newIcon: _chevronLeft.default,
  iconType: "utility"
}));
ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var _default = exports.default = ChevronLeftLargeIcon;